<template>
	<div>
		<v-card elevation="0" :style="'background-color:' + $theme.lightBlue">
			<v-card-title style="font-size: large">
				<v-icon size="20" color="black" style="margin-right: 10px">{{ 'mdi-account-box' }}</v-icon>
				{{ '고객 관리' }}
			</v-card-title>
			<v-data-table
				:style="'cursor: pointer;background-color:' + $theme.lightBlue"
				:headers="this.headers"
				:items="items"
				:search="search"
				@click:row="showItem"
				:items-per-page="100"
				:footerProps="{ 'items-per-page-options': [20, 100, 500, -1] }"
			>
				<template v-slot:top>
					<tr class="d-flex justify-space-between">
						<td style="width: 200px; margin-right: 20px">
							<v-text-field color="black" v-model="search" label="검색" class="mx-4" append-icon="mdi-magnify" style="width: 300px"></v-text-field>
						</td>
					</tr>
				</template>

				<template v-slot:item.userStatusType="props">
					<v-chip v-if="props.item.userStatusType" :color="getColorByUserStatus(props.item.userStatusType)" dark>
						{{ props.item.userStatusTypeName }}
					</v-chip>
					<v-chip v-if="!props.item.userStatusType && props.item.userStatusTypeName">
						{{ props.item.userStatusTypeName }}
					</v-chip>
				</template>

				<template v-slot:item.lastLoginAt="{ item }">
					{{ formatTimestamp(item.lastLoginAt) }}
				</template>

				<template v-slot:item.createAt="{ item }">
					{{ formatTimestamp(item.createAt) }}
				</template>

				<template v-slot:item.updateAt="{ item }">
					{{ formatTimestamp(item.updateAt) }}
				</template>
			</v-data-table>
		</v-card>

		<UserEditDialog
			:show="editDialog"
			:item="selectedItem"
			icon="mdi-account-box"
			title="고객 상세정보"
			okButtonText="확인"
			:okButton="false"
			cancelButtonText="닫기"
			:deleteButton="false"
			deleteButtonText="삭제"
			@onOk="modifyItem"
			@onCancel="
				selectedItem = $models.UserModel.create();
				editDialog = false;
			"
			@onDelete="deleteItemConfirm"
		>
		</UserEditDialog>

		<MessageDialog
			:show="deleteMessageDialog"
			message="삭제하시겠습니까?"
			:okButton="true"
			cancelButtonText="취소"
			:deleteButton="true"
			deleteButtonText="삭제"
			@onOk="deleteItem"
			@onCancel="deleteMessageDialog = false"
		/>
	</div>
</template>

<script>
	import { formatTimestamp } from '@/js/util';
	import { userStatusTypeCode } from '@/js/types'; // 절대 경로 사용

	export default {
		name: 'UserList',
		props: {
			items: {
				default: () => [],
			},
		},
		data: () => ({
			headers,
			search: '',
			selectedItem: {},
			deleteMessageDialog: false,
			formValid: false,
			newItemDialog: false,
			editDialog: false,
		}),
		mounted: function() {},
		methods: {
			formatTimestamp,
			getColorByUserStatus(status) {
				return status == userStatusTypeCode.active.code ? this.$theme.primary : null;
			},
			deleteItemConfirm() {
				this.deleteMessageDialog = true;
			},
			showItem(item) {
				this.selectedItem = this.$models.UserModel.set(item);
				this.selectedItem.uid = item.uid;
				this.editDialog = true;
			},
			// newItem() {
			// 	this.selectedItem = this.$models.UserModel.create();
			// 	this.newItemDialog = true;
			// },
			// async registItem(item) {
			// 	this.selectedItem = this.$models.UserModel.set(item);
			// 	this.$emit('registItem', this.selectedItem);
			// 	this.selectedItem = this.$models.UserModel.create();
			// 	this.newItemDialog = false;
			// },
			async modifyItem(item) {
				this.selectedItem = this.$models.UserModel.set(item);
				this.selectedItem.uid = item.uid;
				this.$emit('modifyItem', this.selectedItem);
				this.selectedItem = this.$models.UserModel.create();
				this.editDialog = false;
			},
			async deleteItem() {
				this.$emit('deleteItem', this.selectedItem.uid);
				this.deleteMessageDialog = false;
				this.editDialog = false;
			},
		},
	};

	const headers = [
		{ text: '이름', align: 'start', sortable: true, value: 'name' },
		{ text: '닉네임', align: 'start', sortable: true, value: 'nickname' },
		{ text: '이메일', align: 'start', sortable: true, value: 'email' },
		{ text: '계정상태', align: 'start', sortable: true, value: 'userStatusType' },
		{ text: '마지막 로그인', align: 'start', sortable: true, value: 'lastLoginAt' },
		{ text: '생성일', align: 'start', sortable: true, value: 'createAt' },
		// { text: '최종수정일', align: 'start', sortable: true, value: 'updateAt' },
	];
</script>

<style scoped></style>
